import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_calendar_line",
  "use": "icon-icon_general_calendar_line-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-icon_general_calendar_line\">\n<path class=\"st0\" d=\"M35,10V8h-2v2H15V8h-2v2H8v6v2v20h32V18v-2v-6H35z M38,36H10V18h28V36z M10,16v-4h3v2h2v-2h18v2h2v-2h3v4H10z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol